import React from "react";
import _pub63C09B0F from "./__DEPRECATED__typography.pc";
import _pubA97D53F3 from "./atoms.pc";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import _pub5Ab99334 from "./TextInput.pc";
import _pubC414D24 from "./ErrorText.pc";
import _pub824B8933, {FormLayout as _pub824B8933_FormLayout} from "./layout.pc";
import _pub2Dbb4493 from "./Button.pc";
import "./Field.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement("div", {
    "className": "_223ea9ae _df2a042 _pub-df2a042 _pub-a97d53f3" + " " + "_df2a042_Field _pub-df2a042_Field _pub-a97d53f3_Field Field " + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : "") + (props["hidden"] ? " " + "_df2a042_hidden _pub-df2a042_hidden _pub-a97d53f3_hidden hidden" : "") + (props["secondary"] ? " " + "_df2a042_secondary_field _pub-df2a042_secondary_field _pub-a97d53f3_secondary_field secondary_field" : "") + (props["v3"] ? " " + "_df2a042_secondary_field _pub-df2a042_secondary_field _pub-a97d53f3_secondary_field secondary_field _df2a042_v3 _pub-df2a042_v3 _pub-a97d53f3_v3 v3" : "") + (props["v4"] ? " " + "_df2a042_secondary_field _pub-df2a042_secondary_field _pub-a97d53f3_secondary_field secondary_field _df2a042_v3 _pub-df2a042_v3 _pub-a97d53f3_v3 v3 _df2a042_v4 _pub-df2a042_v4 _pub-a97d53f3_v4 v4" : "") + (props["success"] ? " " + "_df2a042_success _pub-df2a042_success _pub-a97d53f3_success success" : "") + (props["positive"] ? " " + "_df2a042_positive _pub-df2a042_positive _pub-a97d53f3_positive positive" : "") + (props["negative"] ? " " + "_df2a042_negative _pub-df2a042_negative _pub-a97d53f3_negative negative" : "") + (props["left"] ? " " + "_df2a042_left _pub-df2a042_left _pub-a97d53f3_left left" : "") + (props["toggle"] ? " " + "_df2a042_toggle _pub-df2a042_toggle _pub-a97d53f3_toggle toggle" : "") + (props["companyAnalyses"] ? " " + "_df2a042_company-analyses _pub-df2a042_company-analyses _pub-a97d53f3_company-analyses company-analyses" : "") + (props["spaceBottom"] ? " " + "_df2a042_space-bottom _pub-df2a042_space-bottom _pub-a97d53f3_space-bottom space-bottom" : "") + (props["fail"] ? " " + "_df2a042_fail _pub-df2a042_fail _pub-a97d53f3_fail fail" : "") + (props["active"] ? " " + "_df2a042_active _pub-df2a042_active _pub-a97d53f3_active active" : "") + (props["noSpace"] ? " " + "_df2a042_no-space _pub-df2a042_no-space _pub-a97d53f3_no-space no-space" : "") + (props["last"] ? " " + "_df2a042__last _pub-df2a042__last _pub-a97d53f3__last _last" : ""),
    "ref": ref,
    "data-testid": props["testId"],
    "onFocus": props["onFocus"],
    "onBlur": props["onBlur"],
  }, 
    React.createElement("div", {
      "className": "_afa3e03f _df2a042 _pub-df2a042 _pub-a97d53f3",
    }, 
      React.createElement("label", {
        "className": "_c8f92fcd _df2a042 _pub-df2a042 _pub-a97d53f3" + " " + "_df2a042_label _pub-df2a042_label _pub-a97d53f3_label label _df2a042_font-body _pub-df2a042_font-body _pub-a97d53f3_font-body font-body" + (props["label"] ? " " + "_df2a042_exists _pub-df2a042_exists _pub-a97d53f3_exists exists" : ""),
        "htmlFor": props["for"],
      }, 
        props["label"]
      ),
      props["children"]
    ),
    React.createElement("div", {
      "className": "_36aab185 _df2a042 _pub-df2a042 _pub-a97d53f3" + " " + "_df2a042_subtext _pub-df2a042_subtext _pub-a97d53f3_subtext subtext _df2a042_font-body _pub-df2a042_font-body _pub-a97d53f3_font-body font-body",
    }, 
      props["subtext"]
    )
  )
}));
export default $$Default;


